"use client";
import { useState, useEffect } from "react";
import Image from "@/components/Image";
import React from "react";
// import { DeviceType, getDeviceTypeByUA } from "@/app/utils";

const AdvantageXy = () => {
  const [activeTab, setActiveTab] = useState(3);
  const [deviceType, setDeviceType] = useState<string>("other");

  const tab1Content = [
    {
      title: "智能批改，减轻老师纸质作业批改负担",
      desc: [
        "自动批改手写作业，支持多学科、多题型唯一答案",
        "自动打印批改痕迹，模拟教师手批效果",
        "A I分析作业学情，自动生成报告",
        "不改变老师原有作业布置习惯",
        "老师无需重复机械“劳作”",
      ],
      img: "/pic1_xy_02.png",
    },
    {
      title: "课堂模式，精准备课（讲评）信手拈来",
      desc: [
        "当前题目作答情况、错误率轻松自动统计 ，无需准备PPT",
        "作业原卷、逐题正确率、学生答题情况一屏展示",
        "默认隐藏学生姓名，保护自尊心",
        "提供电子黑板功能，边讲边互动：放大、缩小、拖动、圈画......",
      ],
      img: "/pic2_xy_02.png",
    },
  ];
  const tab2Content = [
    {
      title: "原卷手写采集，学生“远离”电子产品",
      desc: [
        "无需特殊纸笔和学生终端",
        "不改变学生手写作答习惯",
        "“字迹潦草”亦可自动识别",
      ],
      img: "/pic3_xy_02.png",
    },
    {
      title: "作业学情报告，个人成长看的见",
      desc: [
        "个人错题本自动生成，过程性评价可视化",
        "学生学情自动收录，知识点分析标识正确率，学习薄弱项数据化",
        "个人成绩纵横比，发现自我成长，激发学生自主性",
      ],
      img: "/pic4_xy_02.png",
    },
  ];

  const tab3Content = [
    {
      title: "多终端布置采集，校方部署无压力",
      desc: [
        "配备蜜蜂智阅一体机，支持老师手机端布置操作任务",
        "支持与学校智慧教育平台数据对接，提供入校运维服务",
        "陪伴式教师培训，线上答疑及时响应",
      ],
      img: "/pic5_xy_02.png",
    },
    {
      title: "教学资源入库，AI精准教学添翼增效",
      desc: [
        "云端题库、涵盖海量试题，全学科、全学段、多教材版本",
        "支持对接第三方教学资源互通，纸质资源系统化智能入库",
        "批改留痕，易错薄弱点一目了然，老师个性化教学有的放矢",
      ],
      img: "/pic6_xy_02.png",
    },
    {
      title: "学情大数据分析，学科素养发展可视化",
      desc: [
        "采集分析学生学习过程中的课后作业、单元素养测评",
        "学生学情按知识点标识正确率，查漏补缺夯实基础事半功倍",
        "阶段学情涵盖知识点分析、错题分析，告别“题海战术”高效学习",
        "支持对学生的学习行为和成绩横向",
        "学生共性问题和个性问题的筛选、分析，为老师提供更精准的教学辅助",
      ],
      img: "/pic7_xy_02.png",
    },
  ];
  // 在组件挂载时获取设备类型
  useEffect(() => {
    import("current-device").then((module) => {
      const deviceType = module.default.type;
      setDeviceType(deviceType);
      if (deviceType === "desktop") {
        setDeviceType("pc");
      }
      if (deviceType === "unknown") {
        setDeviceType("other");
      }
    });
  }, []);

  // 渲染方式同上
  return (
    <section className="flex w-full px-[80px] [@media(min-width:769px)_and_(max-width:1080px)]:px-[40px] [@media(max-width:768px)]:px-[20px] bg-white mx-auto">
      {/* 主体部分 */}
      <div className="flex flex-col w-full max-w-[1360px] mx-auto gap-[80px] pt-[90px] pb-[120px] justify-center items-center">
        {/* 上面部分 - 标题区域 */}
        <div className="flex flex-col w-full  mx-auto items-center justify-center gap-[120px]  [@media(max-width:1080px)]:gap-[60px]">
          {/* 标题文字 */}
          <h2 className="h-auto font-semibold text-[46px] leading-[52px] tracking-[0px] text-[#333333] text-center">
            蜜蜂家校核心优势
          </h2>
          {/* tab控制 */}
          <div className="flex flex-col w-full mx-auto items-center justify-center gap-[20px]">
            {/* tab控制1 */}
            <div className="flex flex-row w-full mx-auto items-center justify-center gap-[20px] rounded-[8px] bg-[#F8FAFD]">
              <div
                onClick={() => {
                  setActiveTab(1);
                  window.Log.action(
                    "sub_tab_click",
                    {
                      sub_tab: "师",
                      user_access_port: deviceType,
                    },

                    "HWOfficialPaidSchoolVersionPage",
                  );
                }}
                className={`${activeTab === 1 ? "bg-[#1DBA55]" : ""} flex w-full mx-auto gap-2.5 py-3.5 max-px-[62px] rounded-lg items-center justify-center relative cursor-pointer`}
              >
                <div className="flex [@media(max-width:1080px)]:hidden">
                  {/* 上方悬浮图片 */}
                  {activeTab === 1 ? (
                    <div
                      className="absolute left-1/2 -translate-x-1/2"
                      style={{ top: "-100px" }}
                    >
                      <Image
                        src="/icon1_xy_02.png"
                        alt="icon1_xy_02"
                        className="object-contain w-[159px]" // 你可以根据需要调整宽高
                        width={159}
                        height={99}
                      />
                    </div>
                  ) : (
                    <div
                      className="absolute left-1/2 -translate-x-1/2"
                      style={{ top: "-76px" }}
                    >
                      <Image
                        src="/icon1_xy_02.png"
                        alt="icon1_xy_02"
                        className="object-contain w-[106px]"
                        width={106}
                        height={66}
                      />
                    </div>
                  )}
                </div>
                <div
                  className={`${activeTab === 1 ? "text-white font-[600]" : "font-[400] text-[#999999] hover:text-[#1DBA55]"} flex px-[14px] min-h-[52px] items-center justify-center text-xl leading-[52px] [@media(max-width:600px)]:leading-[24px] tracking-normal text-center`}
                >
                  教师减负提质
                </div>
                {activeTab === 1 && (
                  <div className="absolute bottom-[-1] left-1/2 transform -translate-x-1/2">
                    <Image
                      src="/icon_xy_02.png"
                      alt="advantage_xy_01"
                      className="object-contain w-[16px] "
                      width={16}
                      height={10}
                    />
                  </div>
                )}
              </div>
              <div
                onClick={() => {
                  setActiveTab(2);
                  window.Log.action(
                    "sub_tab_click",
                    {
                      sub_tab: "生",
                      user_access_port: deviceType,
                    },
                    "HWOfficialPaidSchoolVersionPage",
                  );
                }}
                className={`${activeTab === 2 ? "bg-[#1DBA55]" : ""} flex w-full mx-auto gap-2.5 py-3.5 max-px-[62px] rounded-lg items-center justify-center relative cursor-pointer`}
              >
                <div className="flex [@media(max-width:1080px)]:hidden">
                  {/* 上方悬浮图片 */}
                  {activeTab === 2 ? (
                    <div
                      className="absolute left-1/2 -translate-x-1/2"
                      style={{ top: "-100px" }}
                    >
                      <Image
                        src="/icon2_xy_02.png"
                        alt="icon2_xy_02"
                        className="object-contain w-[159px]" // 你可以根据需要调整宽高
                        width={159}
                        height={99}
                      />
                    </div>
                  ) : (
                    <div
                      className="absolute left-1/2 -translate-x-1/2"
                      style={{ top: "-76px" }}
                    >
                      <Image
                        src="/icon2_xy_02.png"
                        alt="icon2_xy_02"
                        className="object-contain w-[106px]"
                        width={106}
                        height={66}
                      />
                    </div>
                  )}
                </div>
                <div
                  className={`${activeTab === 2 ? "text-white font-[600]" : "font-[400] text-[#999999] hover:text-[#1DBA55]"} flex px-[14px] min-h-[52px] items-center justify-center text-[20px] leading-[52px] [@media(max-width:600px)]:leading-[24px] tracking-normal text-center`}
                >
                  学生个性化学习
                </div>
                {activeTab === 2 && (
                  <div className="absolute bottom-[-1] left-1/2 transform -translate-x-1/2">
                    <Image
                      src="/icon_xy_02.png"
                      alt="advantage_xy_01"
                      className="object-contain w-[16px] "
                      width={16}
                      height={10}
                    />
                  </div>
                )}
              </div>
              <div
                onClick={() => {
                  setActiveTab(3);
                  window.Log.action(
                    "sub_tab_click",
                    {
                      sub_tab: "校",
                      user_access_port: deviceType,
                    },
                    "HWOfficialPaidSchoolVersionPage",
                  );
                }}
                className={`${activeTab === 3 ? "bg-[#1DBA55]" : ""} flex w-full mx-auto gap-2.5 py-3.5 max-px-[62px] rounded-lg items-center justify-center relative cursor-pointer`}
              >
                <div className="flex [@media(max-width:1080px)]:hidden">
                  {/* 上方悬浮图片 */}
                  {activeTab === 3 ? (
                    <div
                      className="absolute left-1/2 -translate-x-1/2"
                      style={{ top: "-100px" }}
                    >
                      <Image
                        src="/icon3_xy_02.png"
                        alt="icon3_xy_02"
                        className="object-contain w-[159px]" // 你可以根据需要调整宽高
                        width={159}
                        height={99}
                      />
                    </div>
                  ) : (
                    <div
                      className="absolute left-1/2 -translate-x-1/2"
                      style={{ top: "-76px" }}
                    >
                      <Image
                        src="/icon3_xy_02.png"
                        alt="icon3_xy_02"
                        className="object-contain w-[106px]"
                        width={106}
                        height={66}
                      />
                    </div>
                  )}
                </div>
                <div
                  className={`${activeTab === 3 ? "text-white font-[600]" : "font-[400] text-[#999999] hover:text-[#1DBA55]"} flex px-[14px] h-[52px] items-center justify-center text-[20px] leading-[52px] [@media(max-width:600px)]:leading-[24px] tracking-normal text-center `}
                >
                  校园数智化管理
                </div>
                {activeTab === 3 && (
                  <div className="absolute bottom-[-1] left-1/2 transform -translate-x-1/2">
                    <Image
                      src="/icon_xy_02.png"
                      alt="advantage_xy_01"
                      className="object-contain w-[16px] "
                      width={16}
                      height={10}
                    />
                  </div>
                )}
              </div>
            </div>
            <div className="gap-[20px] w-full [@media(max-width:660px)]:gap-[4px]">
              {/* tab控制21 */}
              {activeTab === 1 && (
                <div className="flex flex-row w-full mx-auto items-center justify-center gap-[20px] [@media(max-width:1080px)]:gap-0 px-[40px] [@media(max-width:1080px)]:px-[20px] [@media(max-width:660px)]:hidden">
                  {[
                    "智能批改",
                    "原卷留痕",
                    "智能分析",
                    "精准备课",
                    "精准讲评",
                    "学情监管",
                  ].map((text, idx, arr) => (
                    <>
                      {/* 组件 */}
                      <div className="flex w-full mx-auto items-center justify-center ">
                        <div className="flex flex-row mx-auto max-px-[14px] py-[12px] gap-[4px] ">
                          <div className="flex w-[18px] h-[18px] mx-auto font-normal text-sm leading-[18px] tracking-[0.06em] text-gray-500">
                            <Image
                              src="/true_xy_02.png"
                              alt="advantage_xy_01"
                              className="object-contain w-[18px]"
                              width={18}
                              height={18}
                            />
                          </div>
                          <div className="flex mx-auto font-normal text-sm leading-[18px] tracking-[0.06em] text-gray-500">
                            {text}
                          </div>
                        </div>
                      </div>
                      {/* 分割线，最后一个不渲染 */}
                      {idx < arr.length - 1 && (
                        <div className="h-6 border border-gray-200"></div>
                      )}
                    </>
                  ))}
                </div>
              )}

              {/* tab控制21 42*/}
              {activeTab === 1 && (
                <div className="hidden flex-row mx-auto items-center justify-center gap-[20px] [@media(max-width:1080px)]:gap-[10px] px-[40px] [@media(max-width:1080px)]:px-[20px] [@media(min-width:601px)_and_(max-width:660px)]:flex  [@media(max-width:660px)]:hidden">
                  {["智能批改", "原卷留痕", "智能分析", "精准备课"].map(
                    (text) => (
                      <>
                        {/* 组件 */}
                        <div className="flex w-full mx-auto items-center justify-center ">
                          <div className="flex flex-row mx-auto px-[14px] py-[12px] gap-[4px] ">
                            <div className="flex w-[18px] h-[18px] mx-auto font-normal text-sm leading-[18px] tracking-[0.06em] text-gray-500">
                              <Image
                                src="/true_xy_02.png"
                                alt="advantage_xy_01"
                                className="object-contain w-[18px]"
                                width={18}
                                height={18}
                              />
                            </div>
                            <div className="flex mx-auto font-normal text-sm leading-[18px] tracking-[0.06em] text-gray-500">
                              {text}
                            </div>
                          </div>
                        </div>
                        <div className="h-6 border border-gray-200"></div>
                      </>
                    ),
                  )}
                </div>
              )}
              {/* tab控制21 42*/}
              {activeTab === 1 && (
                <div className="hidden flex-row w-auto mx-auto items-center justify-center gap-[20px] [@media(max-width:1080px)]:gap-[10px] px-[40px] [@media(max-width:1080px)]:px-[5px] [@media(min-width:601px)_and_(max-width:660px)]:flex  [@media(max-width:660px)]:hidden">
                  {["精准讲评", "学情监管"].map((text, idx) => (
                    <>
                      {/* 组件 */}
                      <div className="flex  items-center justify-center">
                        <div className="flex flex-row mx-auto px-[14px] py-[12px] gap-[4px] ">
                          <div className="flex w-[18px] h-[18px] mx-auto font-normal text-sm leading-[18px] tracking-[0.06em] text-gray-500">
                            <Image
                              src="/true_xy_02.png"
                              alt="advantage_xy_01"
                              className="object-contain w-[18px]"
                              width={18}
                              height={18}
                            />
                          </div>
                          <div className="flex mx-auto font-normal text-sm leading-[18px] tracking-[0.06em] text-gray-500">
                            {text}
                          </div>
                        </div>
                      </div>
                      {idx < 1 && (
                        <div className="h-6 border border-gray-200"></div>
                      )}
                    </>
                  ))}
                </div>
              )}

              {/* tab控制21 33*/}
              {activeTab === 1 && (
                <>
                  <div className="hidden flex-row mx-auto items-center justify-center gap-[20px] [@media(max-width:1080px)]:gap-[10px] px-[40px] [@media(max-width:1080px)]:px-[20px] [@media(min-width:470px)_and_(max-width:600px)]:flex  [@media(max-width:600px)]:hidden">
                    {["智能批改", "原卷留痕", "智能分析"].map((text) => (
                      <>
                        {/* 组件 */}
                        <div className="flex w-full mx-auto items-center justify-center ">
                          <div className="flex flex-row mx-auto px-[14px] py-[12px] gap-[4px] ">
                            <div className="flex w-[18px] h-[18px] mx-auto font-normal text-sm leading-[18px] tracking-[0.06em] text-gray-500">
                              <Image
                                src="/true_xy_02.png"
                                alt="advantage_xy_01"
                                className="object-contain w-[18px]"
                                width={18}
                                height={18}
                              />
                            </div>
                            <div className="flex mx-auto font-normal text-sm leading-[18px] tracking-[0.06em] text-gray-500">
                              {text}
                            </div>
                          </div>
                        </div>
                        <div className="h-6 border border-gray-200"></div>
                      </>
                    ))}
                  </div>
                  <div className="hidden flex-row mx-auto items-center justify-center gap-[20px] [@media(max-width:1080px)]:gap-[10px] px-[40px] [@media(max-width:1080px)]:px-[20px] [@media(min-width:470px)_and_(max-width:600px)]:flex  [@media(max-width:600px)]:hidden">
                    {["精准备课", "精准讲评", "学情监管"].map((text, idx) => (
                      <>
                        {/* 组件 */}
                        <div className="flex w-full mx-auto items-center justify-center ">
                          <div className="flex flex-row mx-auto px-[14px] py-[12px] gap-[4px] ">
                            <div className="flex w-[18px] h-[18px] mx-auto font-normal text-sm leading-[18px] tracking-[0.06em] text-gray-500">
                              <Image
                                src="/true_xy_02.png"
                                alt="advantage_xy_01"
                                className="object-contain w-[18px]"
                                width={18}
                                height={18}
                              />
                            </div>
                            <div className="flex mx-auto font-normal text-sm leading-[18px] tracking-[0.06em] text-gray-500">
                              {text}
                            </div>
                          </div>
                        </div>
                        {idx < 2 && (
                          <div className="h-6 border border-gray-200"></div>
                        )}
                      </>
                    ))}
                  </div>
                </>
              )}
              {/* tab控制21 22*/}
              {activeTab === 1 && (
                <>
                  <div className="hidden flex-row mx-auto items-center justify-center gap-[20px] [@media(max-width:1080px)]:gap-[10px] px-[40px] [@media(max-width:1080px)]:px-[20px]  [@media(max-width:469px)]:flex">
                    {["智能批改", "原卷留痕"].map((text) => (
                      <>
                        {/* 组件 */}
                        <div className="flex w-full mx-auto items-center justify-center ">
                          <div className="flex flex-row mx-auto px-[14px] py-[12px] gap-[4px] ">
                            <div className="flex w-[18px] h-[18px] mx-auto font-normal text-sm leading-[18px] tracking-[0.06em] text-gray-500">
                              <Image
                                src="/true_xy_02.png"
                                alt="advantage_xy_01"
                                className="object-contain w-[18px]"
                                width={18}
                                height={18}
                              />
                            </div>
                            <div className="flex mx-auto font-normal text-sm leading-[18px] tracking-[0.06em] text-gray-500">
                              {text}
                            </div>
                          </div>
                        </div>
                        <div className="h-6 border border-gray-200"></div>
                      </>
                    ))}
                  </div>
                  <div className="hidden flex-row mx-auto items-center justify-center gap-[20px] [@media(max-width:1080px)]:gap-[10px] px-[40px] [@media(max-width:1080px)]:px-[20px]  [@media(max-width:469px)]:flex">
                    {["智能分析", "精准备课"].map((text) => (
                      <>
                        {/* 组件 */}
                        <div className="flex w-full mx-auto items-center justify-center ">
                          <div className="flex flex-row mx-auto px-[14px] py-[12px] gap-[4px] ">
                            <div className="flex w-[18px] h-[18px] mx-auto font-normal text-sm leading-[18px] tracking-[0.06em] text-gray-500">
                              <Image
                                src="/true_xy_02.png"
                                alt="advantage_xy_01"
                                className="object-contain w-[18px]"
                                width={18}
                                height={18}
                              />
                            </div>
                            <div className="flex mx-auto font-normal text-sm leading-[18px] tracking-[0.06em] text-gray-500">
                              {text}
                            </div>
                          </div>
                        </div>
                        <div className="h-6 border border-gray-200"></div>
                      </>
                    ))}
                  </div>
                  <div className="hidden flex-row mx-auto items-center justify-center gap-[20px] [@media(max-width:1080px)]:gap-[10px] px-[40px] [@media(max-width:1080px)]:px-[20px]   [@media(max-width:469px)]:flex">
                    {["精准讲评", "学情监管"].map((text, idx) => (
                      <>
                        {/* 组件 */}
                        <div className="flex w-full mx-auto items-center justify-center ">
                          <div className="flex flex-row mx-auto px-[14px] py-[12px] gap-[4px] ">
                            <div className="flex w-[18px] h-[18px] mx-auto font-normal text-sm leading-[18px] tracking-[0.06em] text-gray-500">
                              <Image
                                src="/true_xy_02.png"
                                alt="advantage_xy_01"
                                className="object-contain w-[18px]"
                                width={18}
                                height={18}
                              />
                            </div>
                            <div className="flex mx-auto font-normal text-sm leading-[18px] tracking-[0.06em] text-gray-500">
                              {text}
                            </div>
                          </div>
                        </div>
                        {idx < 1 && (
                          <div className="h-6 border border-gray-200"></div>
                        )}
                      </>
                    ))}
                  </div>
                </>
              )}

              {/* tab控制22 */}
              {activeTab === 2 && (
                <div className="flex flex-row w-full mx-auto items-center justify-center gap-[20px] [@media(max-width:1080px)]:gap-0 px-[40px] [@media(max-width:1080px)]:px-[20px] [@media(max-width:660px)]:hidden">
                  {[
                    "摆脱题海",
                    "查漏补缺",
                    "错题收集",
                    "个人报告",
                    "举一反三",
                    "学业分析",
                  ].map((text, idx, arr) => (
                    <>
                      {/* 组件 */}
                      <div className="flex w-full mx-auto items-center justify-center ">
                        <div className="flex flex-row mx-auto max-px-[14px] py-[12px] gap-[4px] ">
                          <div className="flex w-[18px] h-[18px] mx-auto font-normal text-sm leading-[18px] tracking-[0.06em] text-gray-500">
                            <Image
                              src="/true_xy_02.png"
                              alt="advantage_xy_01"
                              className="object-contain w-[18px]"
                              width={18}
                              height={18}
                            />
                          </div>
                          <div className="flex mx-auto font-normal text-sm leading-[18px] tracking-[0.06em] text-gray-500">
                            {text}
                          </div>
                        </div>
                      </div>
                      {/* 分割线，最后一个不渲染 */}
                      {idx < arr.length - 1 && (
                        <div className="h-6 border border-gray-200"></div>
                      )}
                    </>
                  ))}
                </div>
              )}
              {/* tab控制22 42*/}
              {activeTab === 2 && (
                <div className="hidden flex-row mx-auto items-center justify-center gap-[20px] [@media(max-width:1080px)]:gap-[10px] px-[40px] [@media(max-width:1080px)]:px-[20px] [@media(min-width:601px)_and_(max-width:660px)]:flex  [@media(max-width:660px)]:hidden">
                  {["摆脱题海", "查漏补缺", "错题收集", "个人报告"].map(
                    (text) => (
                      <>
                        {/* 组件 */}
                        <div className="flex w-full mx-auto items-center justify-center ">
                          <div className="flex flex-row mx-auto px-[14px] py-[12px] gap-[4px] ">
                            <div className="flex w-[18px] h-[18px] mx-auto font-normal text-sm leading-[18px] tracking-[0.06em] text-gray-500">
                              <Image
                                src="/true_xy_02.png"
                                alt="advantage_xy_01"
                                className="object-contain w-[18px]"
                                width={18}
                                height={18}
                              />
                            </div>
                            <div className="flex mx-auto font-normal text-sm leading-[18px] tracking-[0.06em] text-gray-500">
                              {text}
                            </div>
                          </div>
                        </div>
                        <div className="h-6 border border-gray-200"></div>
                      </>
                    ),
                  )}
                </div>
              )}
              {/* tab控制22 42*/}
              {activeTab === 2 && (
                <div className="hidden flex-row w-auto mx-auto items-center justify-center gap-[20px] [@media(max-width:1080px)]:gap-[10px] px-[40px] [@media(max-width:1080px)]:px-[5px] [@media(min-width:601px)_and_(max-width:660px)]:flex  [@media(max-width:660px)]:hidden">
                  {["举一反三", "学业分析"].map((text, idx) => (
                    <>
                      {/* 组件 */}
                      <div className="flex items-center justify-center">
                        <div className="flex flex-row mx-auto px-[14px] py-[12px] gap-[4px] ">
                          <div className="flex w-[18px] h-[18px] mx-auto font-normal text-sm leading-[18px] tracking-[0.06em] text-gray-500">
                            <Image
                              src="/true_xy_02.png"
                              alt="advantage_xy_01"
                              className="object-contain w-[18px]"
                              width={18}
                              height={18}
                            />
                          </div>
                          <div className="flex mx-auto font-normal text-sm leading-[18px] tracking-[0.06em] text-gray-500">
                            {text}
                          </div>
                        </div>
                      </div>
                      {idx < 1 && (
                        <div className="h-6 border border-gray-200"></div>
                      )}
                    </>
                  ))}
                </div>
              )}

              {/* tab控制22 33*/}
              {activeTab === 2 && (
                <>
                  <div className="hidden flex-row mx-auto items-center justify-center gap-[20px] [@media(max-width:1080px)]:gap-[10px] px-[40px] [@media(max-width:1080px)]:px-[20px] [@media(min-width:470px)_and_(max-width:600px)]:flex  [@media(max-width:600px)]:hidden">
                    {["摆脱题海", "查漏补缺", "错题收集"].map((text) => (
                      <>
                        {/* 组件 */}
                        <div className="flex w-full mx-auto items-center justify-center ">
                          <div className="flex flex-row mx-auto px-[14px] py-[12px] gap-[4px] ">
                            <div className="flex w-[18px] h-[18px] mx-auto font-normal text-sm leading-[18px] tracking-[0.06em] text-gray-500">
                              <Image
                                src="/true_xy_02.png"
                                alt="advantage_xy_01"
                                className="object-contain w-[18px]"
                                width={18}
                                height={18}
                              />
                            </div>
                            <div className="flex mx-auto font-normal text-sm leading-[18px] tracking-[0.06em] text-gray-500">
                              {text}
                            </div>
                          </div>
                        </div>
                        <div className="h-6 border border-gray-200"></div>
                      </>
                    ))}
                  </div>
                  <div className="hidden flex-row mx-auto items-center justify-center gap-[20px] [@media(max-width:1080px)]:gap-[10px] px-[40px] [@media(max-width:1080px)]:px-[20px] [@media(min-width:470px)_and_(max-width:600px)]:flex  [@media(max-width:600px)]:hidden">
                    {["个人报告", "举一反三", "学业分析"].map((text, idx) => (
                      <>
                        {/* 组件 */}
                        <div className="flex w-full mx-auto items-center justify-center ">
                          <div className="flex flex-row mx-auto px-[14px] py-[12px] gap-[4px] ">
                            <div className="flex w-[18px] h-[18px] mx-auto font-normal text-sm leading-[18px] tracking-[0.06em] text-gray-500">
                              <Image
                                src="/true_xy_02.png"
                                alt="advantage_xy_01"
                                className="object-contain w-[18px]"
                                width={18}
                                height={18}
                              />
                            </div>
                            <div className="flex mx-auto font-normal text-sm leading-[18px] tracking-[0.06em] text-gray-500">
                              {text}
                            </div>
                          </div>
                        </div>
                        {idx < 2 && (
                          <div className="h-6 border border-gray-200"></div>
                        )}
                      </>
                    ))}
                  </div>
                </>
              )}
              {/* tab控制22 22*/}
              {activeTab === 2 && (
                <>
                  <div className="hidden flex-row mx-auto items-center justify-center gap-[20px] [@media(max-width:1080px)]:gap-[10px] px-[40px] [@media(max-width:1080px)]:px-[20px]  [@media(max-width:469px)]:flex">
                    {["摆脱题海", "查漏补缺"].map((text) => (
                      <>
                        {/* 组件 */}
                        <div className="flex w-full mx-auto items-center justify-center ">
                          <div className="flex flex-row mx-auto px-[14px] py-[12px] gap-[4px] ">
                            <div className="flex w-[18px] h-[18px] mx-auto font-normal text-sm leading-[18px] tracking-[0.06em] text-gray-500">
                              <Image
                                src="/true_xy_02.png"
                                alt="advantage_xy_01"
                                className="object-contain w-[18px]"
                                width={18}
                                height={18}
                              />
                            </div>
                            <div className="flex mx-auto font-normal text-sm leading-[18px] tracking-[0.06em] text-gray-500">
                              {text}
                            </div>
                          </div>
                        </div>
                        <div className="h-6 border border-gray-200"></div>
                      </>
                    ))}
                  </div>
                  <div className="hidden flex-row mx-auto items-center justify-center gap-[20px] [@media(max-width:1080px)]:gap-[10px] px-[40px] [@media(max-width:1080px)]:px-[20px]  [@media(max-width:469px)]:flex">
                    {["错题收集", "个人报告"].map((text) => (
                      <>
                        {/* 组件 */}
                        <div className="flex w-full mx-auto items-center justify-center ">
                          <div className="flex flex-row mx-auto px-[14px] py-[12px] gap-[4px] ">
                            <div className="flex w-[18px] h-[18px] mx-auto font-normal text-sm leading-[18px] tracking-[0.06em] text-gray-500">
                              <Image
                                src="/true_xy_02.png"
                                alt="advantage_xy_01"
                                className="object-contain w-[18px]"
                                width={18}
                                height={18}
                              />
                            </div>
                            <div className="flex mx-auto font-normal text-sm leading-[18px] tracking-[0.06em] text-gray-500">
                              {text}
                            </div>
                          </div>
                        </div>
                        <div className="h-6 border border-gray-200"></div>
                      </>
                    ))}
                  </div>
                  <div className="hidden flex-row mx-auto items-center justify-center gap-[20px] [@media(max-width:1080px)]:gap-[10px] px-[40px] [@media(max-width:1080px)]:px-[20px]   [@media(max-width:469px)]:flex">
                    {["举一反三", "学业分析"].map((text, idx) => (
                      <>
                        {/* 组件 */}
                        <div className="flex w-full mx-auto items-center justify-center ">
                          <div className="flex flex-row mx-auto px-[14px] py-[12px] gap-[4px] ">
                            <div className="flex w-[18px] h-[18px] mx-auto font-normal text-sm leading-[18px] tracking-[0.06em] text-gray-500">
                              <Image
                                src="/true_xy_02.png"
                                alt="advantage_xy_01"
                                className="object-contain w-[18px]"
                                width={18}
                                height={18}
                              />
                            </div>
                            <div className="flex mx-auto font-normal text-sm leading-[18px] tracking-[0.06em] text-gray-500">
                              {text}
                            </div>
                          </div>
                        </div>
                        {idx < 1 && (
                          <div className="h-6 border border-gray-200"></div>
                        )}
                      </>
                    ))}
                  </div>
                </>
              )}

              {/* tab控制23 */}
              {activeTab === 3 && (
                <div className="flex  [@media(max-width:600px)]:hidden flex-row w-full mx-auto items-center justify-center gap-[20px] [@media(max-width:1080px)]:gap-[10px] px-[40px] [@media(max-width:1080px)]:px-[20px]">
                  {[
                    "学校作业管理",
                    "教师教学画像",
                    "学生学情画像",
                    "学科精准教研",
                  ].map((text, idx, arr) => (
                    <>
                      {/* 组件 */}
                      <div className="flex w-full mx-auto items-center justify-center ">
                        <div className="flex flex-row mx-auto py-[12px] gap-[4px] ">
                          <div className="flex w-[18px] h-[18px] mx-auto font-normal text-sm leading-[18px] tracking-[0.06em] text-gray-500">
                            <Image
                              src="/true_xy_02.png"
                              alt="advantage_xy_01"
                              className="object-contain w-[18px]"
                              width={18}
                              height={18}
                            />
                          </div>
                          <div className="flex mx-auto font-normal text-sm leading-[18px] tracking-[0.06em] text-gray-500">
                            {text}
                          </div>
                        </div>
                      </div>
                      {/* 分割线，最后一个不渲染 */}
                      {idx < arr.length - 1 && (
                        <div className="h-6 border border-gray-200"></div>
                      )}
                    </>
                  ))}
                </div>
              )}
              {/* tab控制23 */}
              {activeTab === 3 && (
                <>
                  <div className="hidden  [@media(max-width:600px)]:flex flex-row w-full mx-auto items-center justify-center gap-[20px] [@media(max-width:1080px)]:gap-[10px] px-[40px] [@media(max-width:1080px)]:px-[20px]">
                    {["学校作业管理", "教师教学画像"].map((text) => (
                      <>
                        {/* 组件 */}
                        <div className="flex w-full mx-auto items-center justify-center ">
                          <div className="flex flex-row mx-auto py-[12px] gap-[4px] ">
                            <div className="flex w-[18px] h-[18px] mx-auto font-normal text-sm leading-[18px] tracking-[0.06em] text-gray-500">
                              <Image
                                src="/true_xy_02.png"
                                alt="advantage_xy_01"
                                className="object-contain w-[18px]"
                                width={18}
                                height={18}
                              />
                            </div>
                            <div className="flex mx-auto font-normal text-sm leading-[18px] tracking-[0.06em] text-gray-500">
                              {text}
                            </div>
                          </div>
                        </div>
                        {/* 分割线，最后一个不渲染 */}
                        <div className="h-6 border border-gray-200"></div>
                      </>
                    ))}
                  </div>
                  <div className="hidden  [@media(max-width:600px)]:flex flex-row w-full mx-auto items-center justify-center gap-[20px] [@media(max-width:1080px)]:gap-[10px] px-[40px] [@media(max-width:1080px)]:px-[20px]">
                    {["学生学情画像", "学科精准教研"].map((text, idx, arr) => (
                      <>
                        {/* 组件 */}
                        <div className="flex w-full mx-auto items-center justify-center ">
                          <div className="flex flex-row mx-auto py-[12px] gap-[4px] ">
                            <div className="flex w-[18px] h-[18px] mx-auto font-normal text-sm leading-[18px] tracking-[0.06em] text-gray-500">
                              <Image
                                src="/true_xy_02.png"
                                alt="advantage_xy_01"
                                className="object-contain w-[18px]"
                                width={18}
                                height={18}
                              />
                            </div>
                            <div className="flex mx-auto font-normal text-sm leading-[18px] tracking-[0.06em] text-gray-500">
                              {text}
                            </div>
                          </div>
                        </div>
                        {/* 分割线，最后一个不渲染 */}
                        {idx < arr.length - 1 && (
                          <div className="h-6 border border-gray-200"></div>
                        )}
                      </>
                    ))}
                  </div>
                </>
              )}
            </div>
          </div>
        </div>
        {activeTab === 1 && (
          <div className="flex flex-col w-full mx-auto justify-center gap-[120px] [@media(max-width:1080px)]:gap-[80px] [@media(max-width:1080px)]:max-w-[688px]">
            {tab1Content.map((item, idx) => (
              <div
                className="flex [@media(max-width:1080px)]:flex-col justify-between [@media(max-width:1080px)]:gap-[24px]"
                key={idx}
              >
                <div className="flex [@media(max-width:1080px)]:order-2 flex-col self-start gap-[60px] h-full  w-full [@media(min-width:660px)]:min-w-[480px]">
                  <div className="flex flex-col gap-[10px]">
                    <div className="font-[600] text-[24px] text-black leading-[44px] tracking-normal">
                      {item.title}
                    </div>
                    <div className="text-[#666666] pl-[25px] font-normal text-base leading-8 tracking-normal">
                      <ul style={{ listStyle: "disc" }}>
                        {item.desc.map((li, i) => (
                          <li key={i}>{li}</li>
                        ))}
                      </ul>
                    </div>
                    <a
                      href="#FunctionXy"
                      className="text-[#1DBA55] font-[400] text-[16px] leading-[32px] tracking-normal cursor-pointer"
                      onClick={() => {
                        window.Log.action(
                          "more_function_click",
                          {
                            from_part:
                              idx === 0
                                ? "师_智能批改"
                                : idx === 1
                                  ? "师_课堂模式"
                                  : "",
                            user_access_port: deviceType,
                          },
                          "HWOfficialPaidSchoolVersionPage",
                        );
                      }}
                    >
                      查看校园版更多功能 {">>"}
                    </a>
                  </div>
                  <div className="flex  flex-row gap-[24px]  [@media(max-width:430px)]:gap-[4px]">
                    <a
                      href="https://mifengjiaoyu.feishu.cn/share/base/form/shrcnPtXd6gal9wBuRiBUpjLrKb?prefill_%E7%BA%BF%E7%B4%A2%E6%9D%A5%E6%BA%90=%E5%AE%98%E7%BD%91&hide_%E7%BA%BF%E7%B4%A2%E6%9D%A5%E6%BA%90=1"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="flex items-center justify-center w-[174px] h-[56px] rounded-[30px] py-[14px] [@media(max-width:430px)]:px-[15px] px-[30px] bg-[#1DBA55] text-white text-[18px] font-medium"
                      onClick={() => {
                        window.Log.action(
                          "school_click",
                          {
                            from_part:
                              idx === 0
                                ? "师_智能批改"
                                : idx === 1
                                  ? "师_课堂模式"
                                  : "",
                            user_access_port: deviceType,
                          },
                          "HWOfficialPaidSchoolVersionPage",
                        );
                      }}
                    >
                      校方采购咨询
                    </a>
                    <a
                      href="https://mifengjiaoyu.feishu.cn/share/base/form/shrcng2mebO4szvD0RIF6nQYbmb?prefill_%E5%90%88%E4%BD%9C%E7%8A%B6%E6%80%81=0%25+%E5%85%AC%E6%B5%B7&hide_%E5%90%88%E4%BD%9C%E7%8A%B6%E6%80%81=1"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="flex items-center justify-center w-[193px] h-[56px] rounded-[30px] py-[14px] [@media(max-width:430px)]:px-[15px] px-[30px] bg-[#F7F7F7] text-[#1DBA55] text-[18px] font-medium"
                      onClick={() => {
                        window.Log.action(
                          "service_provider_click",
                          {
                            from_part:
                              idx === 0
                                ? "师_智能批改"
                                : idx === 1
                                  ? "师_课堂模式"
                                  : "",
                            user_access_port: deviceType,
                          },
                          "HWOfficialPaidSchoolVersionPage",
                        );
                      }}
                    >
                      服务商合作咨询
                    </a>
                  </div>
                </div>
                <div className="flex [@media(max-width:1080px)]:order-1 self-center w-full [@media(min-width:660px)]:min-w-[460px]">
                  <Image
                    src={item.img}
                    alt={item.img}
                    className="[@media(max-width:1080px)]:w-[688px]"
                    width={638}
                    height={400}
                  />
                </div>
              </div>
            ))}
          </div>
        )}

        {activeTab === 2 && (
          <div className="flex flex-col w-full mx-auto justify-center gap-[120px] [@media(max-width:1080px)]:gap-[80px] [@media(max-width:1080px)]:max-w-[688px]">
            {tab2Content.map((item, idx) => (
              <div
                className="flex [@media(max-width:1080px)]:flex-col justify-between [@media(max-width:1080px)]:gap-[24px]"
                key={idx}
              >
                <div className="flex [@media(max-width:1080px)]:order-2 flex-col self-start gap-[60px] h-full w-full [@media(min-width:660px)]:min-w-[480px]">
                  <div className="flex flex-col gap-[10px]">
                    <div className="font-[600] text-black text-[24px] leading-[44px] tracking-normal">
                      {item.title}
                    </div>
                    <div className="text-[#666666] pl-[25px] font-normal text-base leading-8 tracking-normal">
                      <ul style={{ listStyle: "disc" }}>
                        {item.desc.map((li, i) => (
                          <li key={i}>{li}</li>
                        ))}
                      </ul>
                    </div>
                    <a
                      href="#FunctionXy"
                      className="text-[#1DBA55] font-[400] text-[16px] leading-[32px] tracking-normal cursor-pointer"
                      onClick={() => {
                        window.Log.action(
                          "more_function_click",
                          {
                            from_part:
                              idx === 0
                                ? "生_原卷手写采集"
                                : idx === 1
                                  ? "生_作业学情报告"
                                  : "",
                            user_access_port: deviceType,
                          },
                          "HWOfficialPaidSchoolVersionPage",
                        );
                      }}
                    >
                      查看校园版更多功能 {">>"}
                    </a>
                  </div>
                  <div className="flex flex-row gap-[24px] [@media(max-width:430px)]:gap-[4px]">
                    <a
                      href="https://mifengjiaoyu.feishu.cn/share/base/form/shrcnPtXd6gal9wBuRiBUpjLrKb?prefill_%E7%BA%BF%E7%B4%A2%E6%9D%A5%E6%BA%90=%E5%AE%98%E7%BD%91&hide_%E7%BA%BF%E7%B4%A2%E6%9D%A5%E6%BA%90=1"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="flex items-center justify-center w-[174px] h-[56px] rounded-[30px] py-[14px] [@media(max-width:430px)]:px-[15px] px-[30px] bg-[#1DBA55] text-white text-[18px] font-medium"
                      onClick={() => {
                        window.Log.action(
                          "school_click",
                          {
                            from_part:
                              idx === 0
                                ? "生_原卷手写采集"
                                : idx === 1
                                  ? "生_作业学情报告"
                                  : "",
                            user_access_port: deviceType,
                          },
                          "HWOfficialPaidSchoolVersionPage",
                        );
                      }}
                    >
                      校方采购咨询
                    </a>
                    <a
                      href="https://mifengjiaoyu.feishu.cn/share/base/form/shrcng2mebO4szvD0RIF6nQYbmb?prefill_%E5%90%88%E4%BD%9C%E7%8A%B6%E6%80%81=0%25+%E5%85%AC%E6%B5%B7&hide_%E5%90%88%E4%BD%9C%E7%8A%B6%E6%80%81=1"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="flex items-center justify-center w-[193px] h-[56px] rounded-[30px] py-[14px] [@media(max-width:430px)]:px-[15px] px-[30px] bg-[#F7F7F7] text-[#1DBA55] text-[18px] font-medium"
                      onClick={() => {
                        window.Log.action(
                          "service_provider_click",
                          {
                            from_part:
                              idx === 0
                                ? "生_原卷手写采集"
                                : idx === 1
                                  ? "生_作业学情报告"
                                  : "",
                            user_access_port: deviceType,
                          },
                          "HWOfficialPaidSchoolVersionPage",
                        );
                      }}
                    >
                      服务商合作咨询
                    </a>
                  </div>
                </div>
                <div className="flex [@media(max-width:1080px)]:order-1 self-center w-full [@media(min-width:660px)]:min-w-[460px]">
                  <Image
                    src={item.img}
                    alt={item.img}
                    className="[@media(max-width:1080px)]:w-[688px]"
                    width={638}
                    height={400}
                  />
                </div>
              </div>
            ))}
          </div>
        )}

        {activeTab === 3 && (
          <div className="flex flex-col w-full mx-auto justify-center gap-[120px] [@media(max-width:1080px)]:gap-[80px] [@media(max-width:1080px)]:max-w-[688px]">
            {tab3Content.map((item, idx) => (
              <div
                className="flex [@media(max-width:1080px)]:flex-col justify-between [@media(max-width:1080px)]:gap-[24px]"
                key={idx}
              >
                <div className="flex [@media(max-width:1080px)]:order-2 flex-col self-start gap-[60px] h-full w-full [@media(min-width:660px)]:min-w-[480px]">
                  <div className="flex flex-col gap-[10px]">
                    <div className="font-[600] text-black text-[24px] leading-[44px] tracking-normal">
                      {item.title}
                    </div>
                    <div className="text-[#666666] pl-[25px] font-normal text-base leading-8 tracking-normal">
                      <ul style={{ listStyle: "disc" }}>
                        {item.desc.map((li, i) => (
                          <li key={i}>{li}</li>
                        ))}
                      </ul>
                    </div>
                    <a
                      href="#FunctionXy"
                      className="text-[#1DBA55] font-[400] text-[16px] leading-[32px] tracking-normal cursor-pointer"
                      onClick={() => {
                        window.Log.action(
                          "more_function_click",
                          {
                            from_part:
                              idx === 0
                                ? "校_多终端采集"
                                : idx === 1
                                  ? "校_教学资源入库"
                                  : idx === 2
                                    ? "校_大数据学情分析"
                                    : "",
                            user_access_port: deviceType,
                          },
                          "HWOfficialPaidSchoolVersionPage",
                        );
                      }}
                    >
                      查看校园版更多功能 {">>"}
                    </a>
                  </div>
                  <div className="flex flex-row gap-[24px] [@media(max-width:430px)]:gap-[4px]">
                    <a
                      href="https://mifengjiaoyu.feishu.cn/share/base/form/shrcnPtXd6gal9wBuRiBUpjLrKb?prefill_%E7%BA%BF%E7%B4%A2%E6%9D%A5%E6%BA%90=%E5%AE%98%E7%BD%91&hide_%E7%BA%BF%E7%B4%A2%E6%9D%A5%E6%BA%90=1"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="flex items-center justify-center w-[174px] h-[56px] rounded-[30px] py-[14px] [@media(max-width:430px)]:px-[15px] px-[30px] bg-[#1DBA55] text-white text-[18px] font-medium"
                      onClick={() => {
                        window.Log.action(
                          "school_click",
                          {
                            from_part:
                              idx === 0
                                ? "校_多终端采集"
                                : idx === 1
                                  ? "校_教学资源入库"
                                  : idx === 2
                                    ? "校_大数据学情分析"
                                    : "",
                            user_access_port: deviceType,
                          },
                          "HWOfficialPaidSchoolVersionPage",
                        );
                      }}
                    >
                      校方采购咨询
                    </a>
                    <a
                      href="https://mifengjiaoyu.feishu.cn/share/base/form/shrcng2mebO4szvD0RIF6nQYbmb?prefill_%E5%90%88%E4%BD%9C%E7%8A%B6%E6%80%81=0%25+%E5%85%AC%E6%B5%B7&hide_%E5%90%88%E4%BD%9C%E7%8A%B6%E6%80%81=1"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="flex items-center justify-center w-[193px] h-[56px] rounded-[30px] py-[14px] [@media(max-width:430px)]:px-[15px] px-[30px] bg-[#F7F7F7] text-[#1DBA55] text-[18px] font-medium"
                      onClick={() => {
                        window.Log.action(
                          "service_provider_click",
                          {
                            from_part:
                              idx === 0
                                ? "校_多终端采集"
                                : idx === 1
                                  ? "校_教学资源入库"
                                  : idx === 2
                                    ? "校_大数据学情分析"
                                    : "",
                            user_access_port: deviceType,
                          },
                          "HWOfficialPaidSchoolVersionPage",
                        );
                      }}
                    >
                      服务商合作咨询
                    </a>
                  </div>
                </div>
                <div className="flex [@media(max-width:1080px)]:order-1 self-center w-full [@media(min-width:660px)]:min-w-[460px]">
                  <Image
                    src={item.img}
                    alt={item.img}
                    className="[@media(max-width:1080px)]:w-[688px]"
                    width={638}
                    height={400}
                  />
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </section>
  );
};

export default AdvantageXy;
